import { IResource } from './iresource';

export class ApiMessageDescriptor implements IResource {
  public id: string;
  public href: string;
  public modified: Date;
  public deleted: Date;

  public content: string;
  public created: Date;
  public createdBy: string;
  public visibleUntil: Date;
  public visibleFrom: Date;
  public subject: string;

}



// WEBPACK FOOTER //
// ./src/app/modules/maintenance.message/model/api.message.ts